module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "modal--small",
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Otvori drugu smenu za vozača: " + _vm._s(_vm.displayDate))]), _vm._v(" "), _c('i', {
    staticClass: "ti-close",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Kurir")]), _vm._v(" "), (_vm.newSelectedDriver == null) ? _c('autocompleteObject', {
    attrs: {
      "suggestions": _vm.drivers,
      "placeholder": _vm.placeholderDriver
    },
    on: {
      "update:selectedModel": function($event) {
        return _vm.setNewDriver($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newSelectedDriver != null) ? _c('span', [_vm._v(_vm._s(_vm.newSelectedDriver.name) + " "), _c('button', {
    staticClass: "button-small button-outline",
    staticStyle: {
      "background": "#843534"
    },
    on: {
      "click": function($event) {
        return _vm.deleteDriver()
      }
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Vozilo")]), _vm._v(" "), (_vm.selectedVehicle == null) ? _c('autocompleteObject', {
    attrs: {
      "suggestions": _vm.vehicles,
      "placeholder": _vm.placeholderVehicle
    },
    on: {
      "update:selectedModel": function($event) {
        return _vm.setNewVehicleInRow($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedVehicle != null) ? _c('span', [_vm._v(_vm._s(_vm.selectedVehicle.name) + " "), _c('button', {
    staticClass: "button-small button-outline",
    staticStyle: {
      "background": "#843534"
    },
    on: {
      "click": function($event) {
        return _vm.deleteVehicle()
      }
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Početak smene")]), _vm._v(" "), _c('vue-timepicker', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "format": "HH:mm",
      "close-on-complete": "",
      "auto-scroll": "",
      "drop-direction": "auto"
    },
    model: {
      value: (_vm.choosedTime),
      callback: function($$v) {
        _vm.choosedTime = $$v
      },
      expression: "choosedTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError.length !== 0),
      expression: "hasError.length !== 0"
    }],
    staticClass: "foo"
  }, [_c('div', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.hasError))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [(!_vm.isDisabledAddButton) ? _c('input', {
    staticClass: "input",
    staticStyle: {
      "background": "#2b542c"
    },
    attrs: {
      "type": "button",
      "placeholder": "Dodaj",
      "name": "azuriraj",
      "value": "Dodaj"
    },
    on: {
      "click": function($event) {
        return _vm.addSchedule()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isDisabledAddButton) ? _c('div', {
    staticClass: "foo"
  }, [_c('div', {
    staticClass: "loader",
    staticStyle: {
      "width": "36px",
      "height": "36px"
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03619d29!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/OpenAnotherShiftModal.vue
// module id = 450
// module chunks = 1